import StockList from './List';
// import OrderDetail from './Detail';
import { USER_PERMISSIONS } from '@monorepo/config';

const orderPermissionList = [
  USER_PERMISSIONS.ORDER_CREATE,
  USER_PERMISSIONS.ORDER_VIEW,
  USER_PERMISSIONS.ORDER_APPROVE_STOCK,
  USER_PERMISSIONS.ORDER_WAIT_STOCK,
  USER_PERMISSIONS.ORDER_DENY_STOCK,
  USER_PERMISSIONS.ORDER_CONFIRM_PAYMENT,
  USER_PERMISSIONS.ORDER_EXPORT_STOCK,
  USER_PERMISSIONS.ORDER_ASSIGN_SHIPPER,
  USER_PERMISSIONS.ORDER_COMPLETE,
  USER_PERMISSIONS.ORDER_RECREATE_CART,
  USER_PERMISSIONS.ORDER_CANCEL,
];

const router = [
  {
    key: 'stock',
    title: 'menu.order.orderTitle',
    // icon: <Icon.CustomIcon icon={Icon.faShoppingCart} />,
    permissions: orderPermissionList,
    children: [
      {
        key: 'stock-list',
        title: 'menu.stock.orderList',
        path: '/',
        component: StockList,
        exact: true,
      },
    ],
  },
];

export default router;
